<template>
	<div>
		<div class="flex mt-5">
			<div class="">
				{{$t('classManage.currentLevel')}}: {{teacherInfo.teacher_level.name}}
			</div>
			<div style="flex: 1;" class="ml10 mr10">
				<div class="flex alcenter">
					<div class="progress" role="progressbar" style="width: 260px;"
						aria-label="Success example" aria-valuenow="25" aria-valuemin="0"
						aria-valuemax="100">
						<div class="progress-bar bg-theme" :style="'width:' + ((teacherInfo.teacher_level_value/levelInfo.value_min) * 100)+  '%'"></div>
					</div>
					<div class="ml10">
						({{teacherInfo.teacher_level_value}}/{{levelInfo.value_min}})
					</div>
				</div>
				<div class="ft14 cl-info mt-2">
					<!-- 距離下次升級還有187小時 -->
					{{$t('classManage.upgrade',{hour: ((levelInfo.value_min) - teacherInfo.teacher_level_value)})}}
				</div>
				<div class="ft14 classManage-color mt-3 clickAct" @click="comVisible = true">
					<!-- 查看分成比例 -->
					{{$t('classManage.viewCommissionRatio')}}
				</div>
				
			</div>
		</div>
		<div class="classManage-bg mt-4 p-3 classManage-wid" v-if="getDelay()">
			<div class="">
				<!-- 價錢調整公示中 -->
				{{$t('classManage.priceAdjustmentNotice')}}
			</div>
			<div class="mt-3 flex ">
				<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC"
				@click="formTeacherItemDelay = item.course;formTeacherTypeIdDelay=item.id"
				:class="formTeacherTypeIdDelay==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
					{{item.name}}
				</div>
				
			</div>
			<div class="flex alcenter mt-3" v-for="(it,ind) in formTeacherItemDelay">
				<div>
					{{it.name}}
				</div>
				<div v-for="(itChild,inChild) in it.teacherCourseDelay">
					<div class="p-2 ml10" style="height: 40px;" v-if="itChild.is_experience=='1'">{{$t('common.experienceClass')}}</div>
					<div class="p-2 ml10" style="height: 40px;" v-else-if="itChild.is_experience=='2'&&inChild<=1">
						{{$t('teacherVue.formalClasses')}}
					</div>
					<div class="p-2 ml10" style="height: 40px;" v-else>
						
					</div>
					<div class="border-gray p-2 br4 ml10 classManage-item bg-w" >
						<div class="">
							{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
						</div>
						<div class="cl-info ft10" v-if="itChild.is_experience=='2'">
							<!-- {{itChild.quantity}}堂50分鐘課 -->
							{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
						</div>
						<div class="cl-info ft10" v-else>
							{{$t('common.teatClasstime')}}
						</div>
						<div class="border-theme cl-theme ft10 wid-fit px-2">
							{{itChild.discount}}% off
						</div>
					</div>
				</div>
				
			
				<div class="classManage-color ft12 ml10" v-if="it.teacherCourseDelay.length!=0">
					{{$t('classManage.effectiveTime')}}:{{convertToTimeZone(it.teacherCourseDelay[0].take_effect_time).formattedTime}}
				</div>
				<div class="ml10 ft12 clickAct" @click="teacherCourseDelayDelete(it.id)">
					<!-- 撤銷修改 -->
					{{$t('classManage.revokeModifications')}}
				</div>
			</div>
		</div>
		<!-- 設置課堂種類和價錢 -->
		<!-- <div class="mt-4 ftw600">
			{{$t('classManage.setClassTypeAndPrice')}}
		</div> -->
		<!-- 試堂 -->
		<!-- <div class="mt-2 ft14 ftw600">
			{{$t('classManage.trialClass')}}
		</div>
		<div class="mt-3 flex alcenter">
			<div class="ftw600">
				{{$t('classManage.oneClass25Minutes')}}
			</div>
			<div class="border-gray py-2 px-1 br4 ml10 bg-w">
				{{getCurrency()}}<input type="number" class="ml10 cl-info" style="border: none;width: 60px;" v-model="price" /> 
			</div>
			<button type="button" class="btn btn-theme ml10" @click="update()">{{$t('classManage.save')}}</button>
		</div> -->
		<div class="mt-4 ftw600">
			<!-- 設置課堂種類和價錢 -->
			{{$t('classManage.setClassTypeAndPrice')}}
		</div>
		<button type="button" class="btn btn-theme mt-2" @click="classVisible = true">{{$t('classManage.addCourse')}} </button>
		<div class="mt-4 flex ">
			<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC"
			@click="formTeacherItem = item.course;formTeacherTypeId=item.id"
			:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'classManage-blue border-gray'">
				{{item.name}}
			</div>
		</div>
		<div class="flex alcenter mt-3" v-for="(it,ind) in formTeacherItem">
			<div>
				{{it.name}}
			</div>
			<div v-for="(itChild,inChild) in it.teacherCourse">
				<div class="p-2 ml10" style="height: 40px;" v-if="itChild.is_experience=='1'">{{$t('common.experienceClass')}}</div>
				<div class="p-2 ml10" style="height: 40px;" v-else-if="itChild.is_experience=='2'&&inChild<=1">
					{{$t('teacherVue.formalClasses')}}
				</div>
				<div class="p-2 ml10" style="height: 40px;" v-else>
					
				</div>
				<div class="border-gray p-2 br4 ml10 classManage-item bg-w" >
					<div class="">
						{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
					</div>
					<div class="cl-info ft10" v-if="itChild.is_experience=='2'">
						<!-- {{itChild.quantity}}堂50分鐘課 -->
						{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
					</div>
					<div class="cl-info ft10" v-else>
						{{$t('common.teatClasstime')}}
					</div>
					<div class="border-theme cl-theme ft10 wid-fit px-2">
						{{itChild.discount}}% off
					</div>
				</div>
			</div>
			
			<div class="">
				<div class="p-2" style="height: 40px;"></div>
				<div class="flex">
					<button type="button" class="btn btn-theme cl-w classManage-item ml10 "  @click="setEditClass(formTeacherTypeId,it)">{{$t('classManage.setPrice')}}</button>
					<button type="button" class="btn btn-outline-gray classManage-item ml10 bg-w" @click="teacherCourseDelete(it.id)" >{{$t('common.delete')}}</button>
				</div>
			</div>
			
		</div>
		<div v-if="comVisible">
			<view-commission :visible="comVisible" @cancel="handleCancle"></view-commission>
		</div>
		<!-- 添加课程 -->
		<div v-if="classVisible">
			<add-class :visible="classVisible" @cancel="classHandleCancel" :typeId="courseClassifyId"
			:course_id="courseInfo.course_id" :list="classList" :form="teacherInfo" :money="classMoney" 
			:tCMoney="teacherClassMoney" ></add-class>
		</div>
	</div>
</template>

<script>
	import viewCommission from './viewCommission.vue'
	import addClass from './addClass.vue'
	export default{
		components:{
			viewCommission,
			addClass
		},
		data(){
			return{
				formTeacherC:[],
				formTeacherTypeId:0,
				formTeacherTypeIdDelay:0,
				formTeacherItem:{},
				formTeacherItemDelay:{},
				comVisible:false,
				classVisible:false,
				price:0,
				classMoney:0,//一堂课的钱
				teacherClassMoney:0,//老师一堂课所得
				classList:[
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				],
				classifyList:[],//课程分类
				courseClassifyId:0,//课程分类ID
				courseList:[],
				courseInfo:{
					course_id:0,
					teacherCourse:[]
				},
				levelInfo:{}
			}
		},
		created(){
			// console.log("---------this.teacherInfo",this.teacherInfo);
			this.getClassifyList()
			this.price = this.teacherInfo.experience_price
			this.getLevelList()
		},
		methods:{
			getDelay(){
				let boo = false
				this.formTeacherC.forEach((it,ind)=>{
					it.course.forEach((item,index)=>{
						if(item.teacherCourseDelay&&item.teacherCourseDelay.length>0){
							boo = true
						}
					})
				})
				return boo
			},
			teacherCourseDelayDelete(id){
				this.$confirm({
					title: this.$t('common.wantToDelete'),
					content:  this.$t('common.delete'),
					okText: this.$t('common.confirm'),
					okType: "danger",
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/teacher/teacherCourseDelayDelete',{
							course_id:id
						}).then(res=>{
							this.$message.success( this.$t('common.operationSuccessful'),1,()=>{
								this.getClassifyList()
							})
							
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
				
			},
			getLevelList(){
				this.$http.api('teacher/teacher/levelList').then(res => {
					 res.list.forEach((item,index)=>{
						 if(item.name===this.teacherInfo.teacher_level.name){
							 if(index == res.list.length-1){
								 // 满级
								 item.value_min = item.value_max
								  this.levelInfo = item
							 }else{
								 this.levelInfo = res.list[index+1]
							 }
							 
						 }
					 })
				})
			},
			// 课程分类
			async getClassifyList(teacherCourse){
				await this.$http.api('course/classifyList',{
					includeCourse:1,
					teacherCourse:this.teacherInfo.id
				}).then(res=>{
					this.formTeacherC=res.list
					this.formTeacherTypeId = res.list[0].id
					this.formTeacherTypeIdDelay = res.list[0].id
					this.formTeacherItem = res.list[0].course
					this.formTeacherItemDelay = res.list[0].course
				})
				
			},
			update(){
				this.$http.api('teacher/teacher/update',{
					experience_price:this.price
				}).then(res => {
					this.$message.success(this.$t('common.updataSuccess'),1,()=>{
						
					})
					
				})
			},
			// 设置课程价格
			setEditClass(typeId,classItem){
				this.courseClassifyId = typeId
				this.courseInfo.course_id = classItem.id
				this.classList.forEach((item,index)=>{
					classItem.teacherCourse.forEach((it,ind)=>{
						if(it.quantity==1){
							this.classMoney = Number(it.once_price) 
							this.teacherClassMoney = Number(it.once_price) 
						}
						if(item.num==it.quantity){
							item.discount=it.discount
							item.money=it.once_price
							item.selected=true
						}
					})
				})
				this.getClassMoney()
				this.classVisible = true
			},
			// 计算不同堂数的价钱
			getClassMoney(){
				let num = Number(this.teacherInfo.teacher_level.extraction_ratio)/100 //平台抽成比例
				this.teacherClassMoney = this.classMoney-this.classMoney * num //老师一堂课收到的钱
				this.classList.forEach((item,index)=>{
					if(item.discount>item.max){
						item.discount = item.max
					}
					let disNum = 0
					item.discount !==''?disNum = Number(item.discount)/100:''
					item.showMoney = this.classMoney - this.classMoney*disNum
					item.money = this.teacherClassMoney - this.teacherClassMoney*disNum
					// console.log(item);
				})
			},
			teacherCourseDelete(id){
				this.$confirm({
					title: this.$t('common.wantToDelete'),
					content:  this.$t('common.delete'),
					okText: this.$t('common.confirm'),
					okType: "danger",
					cancelText: this.$t('common.cancel'),
					okButtonProps: {
					    style: { backgroundColor: '#52C4C9',borderColor:'#52C4C9', color: 'white' } // 设置确认按钮颜色
					  },
					onOk: () => {
						this.$http.api('teacher/teacher/teacherCourseDelete',{
							course_id:id
						}).then(res=>{
							this.$message.success( this.$t('common.operationSuccessful'),1,()=>{
								this.getClassifyList(1)
							})
							
						})
					},
					onCancel: () => {
						console.log("Cancel");
					},
				});
				
			},
			handleCancle(){
				this.comVisible = false
			},
			classHandleCancel() {
				this.courseClassifyId = 0
				this.courseInfo.course_id = 0
				this.classList = [
					{
						num:5,
						discount:'',
						pl_discount:'0-9%',
						money:'',
						showMoney:'',
						selected:false,
						max:'9'
					},
					{
						num:10,
						discount:'',
						pl_discount:'0-19%',
						money:'',
						showMoney:'',
						selected:false,
						max:'19'
					},
					{
						num:20,
						discount:'',
						pl_discount:'0-29%',
						money:'',
						showMoney:'',
						selected:false,
						max:'29'
					}
				]
				this.classMoney = 0
				this.teacherClassMoney = 0
				this.classVisible = false
				this.$emit('ok')
				this.getClassifyList(1)
			},
		}
	}
</script>

<style scoped>
	.classManage-color{
		color: #F2784C;
	}
	.classManage-bg{
		background-color: #FFEBE4;
	}
	.classManage-blue{
		background-color: #E4E5EC;
	}
	.classManage-wid{
		width: 980px;
	}
	.classManage-item{
		width: 120px;
		height: 70px;
	}
	@media (max-width:575.98px){
		.classManage-wid{
			width: 100%;
		}
	}
</style>